import React, {useCallback, useEffect, useMemo, useState} from 'react';
import useToggle from '../../cmp/hooks/useToggle';
import Modal from '../../cmp/Modal';
import FormGroup from '../../cmp/form/FormGroup';
import Button from '../../cmp/form/Button';
import {
  buildRefLink,
  isValidEmail,
} from '../../../tools/functions';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import FormattedNumber from '../../cmp/FormattedNumber';
import useObjectState from '../../cmp/hooks/useObjectState';
import Input from '../../cmp/form/Input';
import {useSelector} from 'react-redux';
import {
  FormattedDate,
  FormattedMessage,
  FormattedRelativeTime, FormattedTime,
  useIntl,
} from 'react-intl';
import {randomString} from '../../../tools/func';
import CopyButton from '../../cmp/CopyButton';
import Skeleton from 'react-loading-skeleton';
import {ThreeDotsHorizontalIcon} from '../../../icons/Icons';
import InputGroup from '../../cmp/form/InputGroup';
import * as api from '../../../api';
import {del, get, patch, post} from '../../../api';
import AffiliateSalesLineItemsModalNew
  from '../home/AffiliateSalesLineItemsModalNew';
import QrCodeModal from '../../cmp/qrcodeloader/QRCodeModal';
import SocialShareIcon from '../../cmp/SocialShareIcon';
import {
  FiCheck,
  FiCopy,
  FiEdit,
  FiExternalLink,
  FiShoppingBag,
} from 'react-icons/fi';
import dayjs from '../../../mydayjs';
import BootstrapDropdown from 'react-bootstrap/Dropdown';
import StyledButton from '../../cmp/themed/StyledButton';
import useSwr, {useSWRConfig} from 'swr';
import StateBasedPagination from '../../cmp/StateBasedPagination';
import Spinner from '../../cmp/Spinner';
import useDebounce from '../../cmp/hooks/useDebounce';
import Select from '../../cmp/form/Select';
import LazyRangePicker from '../../cmp/flatpickr/LazyRangePicker';
import RefLinkMaker from '../cmp/RefLinkMaker';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';
import FormattedHelmet from '../../cmp/intl/FormattedHelmet';
import {TimezoneDate, TimezoneTime} from '../../cmp/TimezoneTime';
import {AiOutlineFileExcel} from 'react-icons/ai';
import CopyToClipboard from 'react-copy-to-clipboard';

const fetcher = (url)=>{
  return get(url).then((data)=>{
    return {
      count: data.count,
      showcases:data.showcases.map((i)=>{
        return {
          ...i,
          status: getStatus(i),
        }
      })
    }
  })
}
function PartyLinksIndex() {
  const [limit, setLimit] = useState(30);
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [dates, setDates] = useState(null);
  const _search = useDebounce(search, 500);
  const url = useMemo(()=>{
    const u = new URLSearchParams()
    u.append('limit', String(limit))
    u.append('offset', String(Number(page) * Number(limit)))
    if(status){
      u.append('status', status)
    }
    if(_search){
      u.append('search', _search)
    }
    if(dates && Array.isArray(dates) && dates.length > 0){
      u.append('created_at_min', dayjs(dates[0]).format('YYYY-MM-DD'))
      u.append('created_at_max', dayjs(dates[1]).format('YYYY-MM-DD'))
    }
    return '/showcases?'+u.toString()
  },[limit, page, status, _search, dates])



  const {data, isLoading, mutate} = useSwr(url, fetcher)
  const selectOptions = useMemo(()=>{
    // const hasUpcoming = data?.showcases.some((a)=>a.status === "upcoming")
    return [
        {label:'All', value:''},
        {label:'Active', value:'active'},
        {label:'Ended', value:'ended'},
        {label:'Upcoming', value:'upcoming'},
      ]
  },[data])
  return (
      <>
        <FormattedHelmet id={'Party Links'}/>
        <div className="row mb-2">
          <div className="col-md-8">
            <div>
              <h2><FormattedMessage id={"Party Links"} /></h2>
              <p className={"text-muted"}><FormattedMessage id={"Generate party links for the party host"}/></p>
            </div>
          </div>
          <div
              className="col-md-4 gap-2 d-flex flex-md-row flex-row-reverse align-items-center justify-content-end">
            <div className={"party-download-button"}>
              <DownloadReport url={url} />
            </div>
            <div className={'new_party_button'}>
              <ShowcaseModal mutate={mutate}/>
            </div>
          </div>
        </div>
        <div className={'row g-2 mb-2'}>
          <div className="col-md-4">
            <Input type={"search"} value={search} onChange={setSearch} placeholder={"Search..."} />
          </div>
          <div className="col-md-4">
            <Select options={selectOptions} value={status} onChange={setStatus}/>
          </div>
          <div className="col-md-4">
            <LazyRangePicker
                placeholder={"Filter by dates"}
                onChange={setDates} startDate={dates ? dates[0] : null} endDate={dates ? dates[1] : null}/>
          </div>
        </div>
        <div className="row g-2">
          {
            isLoading ? [1, 2, 3].map((item) => {
                return <div className="col-md-4 mb-2" key={item._id}>
                  <Skeleton height={120} />
                  <Skeleton height={48.5} count={6} />
                </div>
            }) : <>
              {
                data?.showcases.map((item) => {
                  return <div className="col-md-6 col-lg-4 mb-2" key={String(item._id)}>
                    <RenderShowcaseItem mutate={mutate} item={item}/>
                  </div>
                })
              } </>
          }
          <StateBasedPagination limit={limit}
                                setLimit={setLimit}
                                page={page}
                                count={data?.count || 0}
                                goToPage={setPage}/>
        </div>
      </>
  );
}

function DownloadReport({url}){
  const [downloading, setDownloading] = useState(false)
  const download = ()=>{
    setDownloading(true)
    const n = new URL(url, 'https://api.goaffpro.com');
    n.searchParams.append('download', '1')
    n.searchParams.delete('limit')
    n.searchParams.delete('offset')
    n.searchParams.append('tz', Intl.DateTimeFormat().resolvedOptions().timeZone)
    get(`${n.pathname}${n.search}`)
        .then(({url})=>{
          setDownloading(false)
          window.location.href = url;
    })
  }
  return <Button loading={downloading} onClick={download} className={"btn btn-link text-success"}>
    <AiOutlineFileExcel />
  </Button>
}

function Options({id, status, sale_count, ends_at, mutate}){
  const [loading, setLoading] = useState(false)
  const timezone = useSelector((state)=>state.settings.timezone)
  const intl = useIntl()
  const [modalVisible, toggleModal] = useToggle()
  const deleteShowcase = ()=>{
    if(window.confirm(intl.formatMessage({id:'Are you sure you want to delete this party?'}))) {
      setLoading(true)
      del('/showcases/' + id).then(() => {
        setLoading(false)
        mutate()
      })
    }
  }
  const cls = ()=>{
    const msg = intl.formatMessage({id:'Are you sure you want to close this party?'})
    if(window.confirm(msg)) {
      setLoading(true)
      post('/showcases/close/' + id).then(() => {
        setLoading(false)
        mutate()
      })
    }
  }
  const saveNewEndDate = (e)=>{
    if(e){
        e.preventDefault()
            e.stopPropagation();
    }
    patch('/showcases/' + id,{
      ends_at: endDate
    }).then(() => {
      mutate()
    })
    toggleModal()
  }
  const [endDate, setEndDate ] = useState(dayjs(ends_at).tz(timezone).format('YYYY-MM-DD'))
  if(loading){
    return <Spinner size={"sm"} />
  }
  if(status !== "active" && sale_count > 0) return null;
  return <React.Fragment>
    <Modal visible={modalVisible} onSubmit={saveNewEndDate} okText={"Submit"} onCancel={toggleModal} toggle={toggleModal}>
        <FormGroup label={"New end date"}>
          <Input type={"date"} value={endDate} onChange={setEndDate} ></Input>
        </FormGroup>

    </Modal>
    <BootstrapDropdown>
    <BootstrapDropdown.Toggle as={ThreeDotsHorizontalIcon}/>
    <BootstrapDropdown.Menu>
      {
        status === "active" ?
            <div className={"d-none edit_party_dates"}>
              <BootstrapDropdown.Item onClick={toggleModal}>
                <FormattedMessage id={"Edit end date"} />
              </BootstrapDropdown.Item>
            </div>: null
      }
      {
        status === "active" ?
            <div id={"close_party_button"} className={'close_party_button'}>
            <BootstrapDropdown.Item onClick={cls}>
              <FormattedMessage id={"End party"} />
            </BootstrapDropdown.Item>
            </div>: null
      }
      {
        sale_count === 0 ?
          <div id={"delete_party_button"}>
            <BootstrapDropdown.Item onClick={deleteShowcase}><span className="text-danger">Delete</span></BootstrapDropdown.Item>
          </div> : null
      }
    </BootstrapDropdown.Menu>
  </BootstrapDropdown>
  </React.Fragment>
}

function getStatus(item){
  const end = new Date(item.ends_at).getTime();
  const closed = new Date(item.closed_at).getTime()
  const starts = new Date(item.starts_at).getTime();
  const now = Date.now();
  if(starts > now) return 'upcoming';
  if(!item.closed_at && end > now) return 'active';
  else if(item.closed_at && closed  <= end) return 'ended';
  else return "completed";
}
const current_year = new Date().getFullYear()
function RenderShowcaseItem({item, mutate}){
  const status = item.status;
  const partner_portal_subdomain = useSelector((state)=>state.settings.partner_portal_subdomain)
  const [link] = usePartyHostLink(item.sub_id, false)
  return <div className="card">
    <RenderStatusBadge status={status} />
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          {
            item.partyTitle ? <h5>{item.partyTitle}</h5> : null
          }
          <div>

            <div>
              <h6 className={"d-none hostname-unlinked"}>{item.hostName}</h6>
              <h6 className={"hostname-linked"}><a
                  title={"Open public page"}
                  href={`https://${partner_portal_subdomain}/e/${item.ref_code}-${item.sub_id}`} target={"_blank"}>{item.hostName}</a></h6>
              <span>{item.hostEmail}</span>
            </div>
          </div>
          {
            status === 'active' || status === "upcoming" ?
                <div className={`mt-2 ${status}-party-links`}>
              <CopyButton text={item.hostUrl || link}
                          className="btn mr-2 btn-sm btn-outline-primary" title={"Copy link"}/>
              <QRButton link={item.hostUrl || link} />
              <ProductLinkCreator link={link} />
              {/*<CopyPublicLink ref_code={item.ref_code} sub_id={item.sub_id} />*/}
              {/*<EditHostDetailsModal hostName={item.hostName}*/}
              {/*                       onClose={mutate} hostEmail={item.hostEmail} showcaseId={item._id} />*/}
            </div> : null
          }
        </div>
        <div className={"text-right"}>
            <Options id={item._id} mutate={mutate}
                     ends_at={item.ends_at}
                     sale_count={item.orders?.num_orders || 0}
                     status={status} />
        </div>
      </div>
    </div>
    <ul className="list-group list-group-flush">
      {
        item.customerDiscount ? <>
          <ShowcaseListItem title={generateLabel(item.customerDiscount.discountConfig)}>
            <CopyButton text={item.customerDiscount.code} title={item.customerDiscount.code} />
          </ShowcaseListItem>
            </> : null
      }
      <ShowcaseListItem title={"Start date"}>
        <time
            title={dayjs(item.starts_at).format('YYYY-MM-DD HH:mm a')}
            dateTime={dayjs(item.starts_at).format('YYYY-MM-DD HH:mm')}>
          <small className={'text-muted mr-2'}>
          <FormattedTime
              value={new Date(item.starts_at)}
              minute={'numeric'} hour12 hour={'numeric'}
          />
        </small><FormattedDate
            year={current_year !== new Date(item.starts_at).getFullYear() ? 'numeric' : undefined}
            value={new Date(item.starts_at)} day={"numeric"} month={"long"} /></time>
      </ShowcaseListItem>
      {
        status === "ended" ? <ShowcaseListItem title={"End date"}>
          <time>
             <small className={'text-muted mr-2'}>
          <FormattedTime
              value={new Date(item.closed_at)}
                         minute={'numeric'} hour12 hour={'numeric'}/>
        </small>
            <FormattedDate
                year={current_year !== new Date(item.closed_at).getFullYear() ? 'numeric' : undefined}
                value={new Date(item.closed_at)} day={"numeric"} month={"long"} />
          </time>
        </ShowcaseListItem> :
            <ShowcaseListItem title={"End date"}>
              <span>
                <small className={'text-muted mr-2'}>
            <TimezoneTime
                    value={new Date(item.ends_at)}
                    minute={'numeric'} hour12 hour={'numeric'}/>
          </small>
                <TimezoneDate
                    value={new Date(item.ends_at)}
                    year={current_year !== new Date(item.ends_at).getFullYear() ? 'numeric' : undefined}
                    day={"numeric"} month={"long"} /></span>
            </ShowcaseListItem>
      }
      <TotalSales sub_id={item.sub_id}
                  is_active={status === "active"}
                  num_orders={item.orders?.num_orders} />
      <ShowcaseListItem title={"Total Volume"}>
        <span><CurrencyNumber value={item.orders?.subtotal}/></span>
      </ShowcaseListItem>
      {
        item.referred_bookings > 0 ?  <RelatedEvents _id={item._id} referred_bookings={item.referred_bookings} /> : null
      }
      {
        item.rewardAmount > 0 || item.additionalRewards?.length > 0 ?
            <div className="px-1 py-1 party-host-reward-section">
              <div className="px-2 pt-1">
                <h6>Host's reward</h6>
              </div>
              <ul className="list-group">
              {
              item.rewardAmount > 0 ? <>
          <ShowcaseListItem title={generateLabel({discount_value: item.rewardAmount, discount_type: item.rewardType})}>
            <span>{item.rewardCode || <FiCheck className={"text-success"} />}</span>
          </ShowcaseListItem> </> : null
          }
          {
            item.additionalRewards ? item.additionalRewards.map(({label, discountConfig, code})=>{
              return  <ShowcaseListItem key={label || code} title={label || generateLabel(discountConfig)}>
                <span>{code || <FiCheck className={"text-success"} />}</span>
              </ShowcaseListItem>
            }) : null
          }
        </ul>
      </div> : null
      }

    </ul>
  </div>
}

function ProductLinkCreator({link}){
  const [visible, toggle] = useToggle()
  return <>
    <SocialShareIcon onClick={toggle} alt={"Product links"}
                    Cmp={<FiShoppingBag style={{width:22, height:22, strokeWidth:1}} />}/>
    <Modal title={"productLinks"} visible={visible} onClose={toggle}>
      <RefLinkMaker sub_id={new URL(link).searchParams.get('sub_id')} />
    </Modal>
  </>
}

function generateLabel(data){
  const {
    discount_value, discount_type
  } = data || {}
  switch (discount_type){
    case "percentage":
      return `${discount_value}% off coupon`
    default:
      return <><CurrencyNumber value={discount_value || 0} /> off coupon</>
  }
}

function QRButton({link}){
  const [showQrModal, toggleQRModal] = useState(false)
  return <>
      <SocialShareIcon disabled={!link} onClick={()=>toggleQRModal(true)} alt={"QR Code"}
                       src={"/images/qr-code.svg"}/>
    <QrCodeModal value={link} onClose={()=>toggleQRModal(false)} visible={showQrModal}/>
  </>
}

function RenderStatusBadge({status}){
  return <span>
    {
      status === "upcoming" ? <span className="badge badge-warning position-absolute" style={{top:1, right:1}}>upcoming</span> : null
    }
    {
      status === "active" ?
          <span className="badge badge-success position-absolute" style={{top:1, right:1}}>active</span> :  null
    }
    {
      status === "ended"  ?
          <span className="badge badge-warning position-absolute"  style={{top:1, right:1}}>ended</span> : null
    }
    {
      status === "completed"  ? <span className="badge badge-primary position-absolute"  style={{top:1, right:1}}>completed</span> : null
    }
  </span>
}

function RelatedEvents({referred_bookings, _id}){
  const [visible, toggleVisibility] = useToggle()
  return <>
    <ShowcaseListItem title={"Referred Bookings"} onClick={referred_bookings > 0 ? toggleVisibility : null}>
      <span><FormattedNumber value={referred_bookings}/></span>
    </ShowcaseListItem>
    {
      visible  ? <>
        <ShowEventChildren referred_bookings={referred_bookings} showcaseId={_id}/>
      </> : null
    }
  </>
}

function ShowEventChildren({referred_bookings, showcaseId}){
  const {data, isLoading} = useSwr('/showcases/children/'+showcaseId, get)
  return <>
  {
    isLoading ? <LoadingSkeleton height={58} count={referred_bookings} /> :
        data?.children.map((i)=>{
          return <li className={"list-group-item d-flex align-items-start justify-content-between"} key={String(i._id)}>
            <div className="">
              {i.hostName}
              <br/>
              <small>{i.hostEmail}</small>
            </div>
            <div>
              <small title={"Party code"}>{i.sub_id}</small>
            </div>

          </li>
        })
  }
  </>
}
function TotalSales({num_orders, is_active, sub_id}){
  const [visible, toggleVisibility] = useToggle()
  return <>
   <ShowcaseListItem title={"Total Sales"} onClick={toggleVisibility}>
      <span><FormattedNumber value={num_orders}/></span>
    </ShowcaseListItem>
    {
      visible  ? <>
          <ShowPartyOrders sub_id={sub_id} visible={visible} num_orders={num_orders} onClose={toggleVisibility} />
        {
          is_active ?
          <AddOrderToParty sub_id={sub_id} /> : null
        }
      </> : null
    }
    </>
}

function EditHostDetailsModal({showcaseId, hostName, hostEmail, onClose}){
  const [data, setData, replace] = useObjectState({
    name:'',
    email:'',
  })
  useEffect(() => {
    setData({
      name: hostName,
      email: hostEmail,
    })
  }, []);
  const [toggle, setToggle] = useToggle()
  return <>
    <button className={"btn btn-link px-1 text-secondary edit_party_btn"}><FiEdit /></button>
    <Modal title={"Edit host details"} visible={toggle} onClose={setToggle}>
      <FormGroup label={"Host's Name"} required>
        <Input type="text" name={"name"} value={data.name} onChange={setData('name')} />
      </FormGroup>
      <FormGroup label={"Host's Email Address"} required>
        <Input type="email" name={"email"} value={data.email} onChange={setData('email')} />
      </FormGroup>
    </Modal>
  </>
}

function MyOrders({sub_id, visible, value, onChange}){
  const {data, isLoading} = useSwr(visible ? `/showcases/orders?sub_id=${sub_id}`: null, get)
  const options = useMemo(()=>{
    return data?.orders.map((i)=>{
      return {
        label: i.number,
        value: i.id
      }
    }) || []
  },[data])
  return <Select hasEmpty options={options} value={value} onChange={onChange}></Select>
}

function AddOrderToParty({sub_id}){
  const aff_assign_showcase_orders = useSelector((state)=>state.settings.aff_assign_showcase_orders)
  const [visible, toggle] = useToggle()
  const [orderId, setOrderId] = useState(null)
  const {mutate} = useSWRConfig()
  const [submitting, setSubmitting] = useState(false)
  const onSubmit = ()=>{
    setSubmitting(true)
    post('/showcases/assign_order', {
      sub_id,
      order_id: orderId
    }).then(()=>{
      setSubmitting(false)
      mutate('/sales?sub_id='+sub_id+'&conversion_source=party-link')
      toggle()
    })
  }
  if(!aff_assign_showcase_orders) return null;
  return <div className={"border-bottom d-flex align-items-center justify-content-center"}>
    <Modal
        okText={"Submit"}
        disabled={!orderId}
        confirmLoading={submitting}
        onSubmit={onSubmit}
        onCancel={toggle}
        visible={visible} title={<FormattedMessage id={"Add a sale"}/>} onClose={toggle}>
      <FormGroup label={"Order number"} required>
        <MyOrders value={orderId} onChange={setOrderId} visible={visible} sub_id={sub_id} />
      </FormGroup>
    </Modal>
    <button className={"btn btn-link text-center align-self-center"} onClick={toggle}>+ <FormattedMessage id={"Add a sale"}/></button>
  </div>
}

function ShowPartyOrders({sub_id, visible, num_orders, onClose}){
  const {data, isLoading: loading} = useSwr(num_orders > 0 && visible && sub_id ? '/sales?sub_id='+sub_id+'&conversion_source=party-link' : null, get)
  const [selectedOrderId, setSelectedOrderId] = useState(null)
  if(num_orders === 0) return null
  return <>
    {
      loading ? <Skeleton height={36.5} count={num_orders}/> : <ul className={"list-group mt-1 ml-1 mr-1"}>{
        data?.data.map(({site_order_number, customer_name, customer_email, order_value, order_id}) => {
          return <li onClick={()=>setSelectedOrderId(order_id)}
                     style={{cursor:'pointer'}}
                     className={"list-group-item list-group-item-action"}
                     key={String(site_order_number)}>
            <div
                className={'d-flex align-items-center justify-content-between'}>
              <div className="text-primary">
                {site_order_number}
              </div>
              <span><CurrencyNumber value={order_value}/></span>
            </div>
            <div>
              {customer_name}
            </div>
            <small className={"text-muted"}>{customer_email}</small>
          </li>
        })
      }</ul>
    }
    <AffiliateSalesLineItemsModalNew order_id={selectedOrderId} onClose={()=>setSelectedOrderId(null)}/>

  </>
}
function ShowcaseListItem({title, children, onClick}){
  return <li className={`list-group-item d-flex align-items-center justify-content-between ${onClick ? 'list-group-item-action text-primary' : ''}`} style={{cursor:onClick ? 'pointer': 'auto'}} onClick={onClick}>
    <span>{typeof title === "string" ? <FormattedMessage id={title} /> : title}</span>
    <span>{children}</span>
  </li>
}


function usePartyHostLink(defaultSubId, useShortener = true){
  const {ref_code, website, ref_identifiers, referral_link_params,
    shorten_showcase_link,
    default_referral_link,
    auto_url_shortener,
  } = useSelector(useCallback((state)=>{
    return {
      ref_code: state.settings.ref_code,
      default_referral_link: state.settings.default_referral_link,
      website: state.settings.website,
      ref_identifiers: state.settings.ref_identifiers,
      referral_link_params: state.settings.referral_link_params,
      shorten_showcase_link: state.settings.shorten_showcase_link,
      auto_url_shortener: state.settings.auto_url_shortener,
    }
  },[]))
  const [sub_id, setSubId] = useState(defaultSubId)
  const link = useMemo(()=>{
    if(useShortener && auto_url_shortener && shorten_showcase_link && auto_url_shortener === "shopify"){
      return `https://${website}/${ref_code}-${sub_id}`
    }
    const params =  `${referral_link_params ? referral_link_params+'\n' : ''}sub_id=${encodeURIComponent(sub_id || '')}`
    return  buildRefLink(ref_code, default_referral_link || website, ref_identifiers, params)
  },[useShortener, ref_code,default_referral_link, ref_identifiers, referral_link_params, sub_id, website, shorten_showcase_link, auto_url_shortener])
  return [link, setSubId]
}

const createPartyLinks = async (showcaseData)=>{
    const {sub_id, name, email, title, expiresIn, starts_at, parent_showcase_id} = showcaseData;
    const ends_at = dayjs(starts_at || new Date()).add(expiresIn, 'day').format('YYYY-MM-DD')
    return api.post('/showcases', {
      sub_id,
      hostName: name,
      hostEmail: email,
      partyTitle: title,
      expiresIn: expiresIn,
      ends_at,
      starts_at,
      parent_showcase_id: parent_showcase_id || undefined,
    }).then((data) => {
      if (data.error) {
        return data
      } else {
        return {
          success:1
        }
      }
    }).catch((e)=>{
      return {
        error: "Network error"
      }
    })
}
const today = dayjs().format('YYYY-MM-DD')

function ShowcaseModal({mutate}){
  const showcaseConfig = useSelector(useCallback((state)=>state.settings.showcaseConfig,[]))
  const self_email = useSelector((state)=>state.settings.email);
  const [visible, toggle] = useToggle(false)
  const [data, setData, replace] = useObjectState({
    name:'',
    title:'',
    email:'',
    starts_at: dayjs().format('YYYY-MM-DD'),
    sub_id: randomString(),
    parent_showcase_id:'',
  })

  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)
  const onSubmit = useCallback((e)=>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setSaving(true)
    createPartyLinks({
      sub_id: data.sub_id.trim(),
      parent_showcase_id: data.parent_showcase_id,
      name: data.name,
      email: data.email,
      title: data.title,
      starts_at: dayjs(data.starts_at, 'YYYY-MM-DD').isSame(dayjs(), 'day') ? undefined : data.starts_at,
      expiresIn: showcaseConfig?.expirationType === "fixed" ? showcaseConfig.expiresIn : data.expiresIn,
    }).then((data)=>{
      setSaving(false)
      mutate()
      if(data && data.error){
        setError(data)
      }else {
        toggle()
        setTimeout(() => {
          const sub_id = randomString();
          replace({
            title:'',
            name:'',
            email:'',
            starts_at: dayjs().format('YYYY-MM-DD'),
            sub_id,
          })
          setSubId(sub_id)
        }, 500)
      }
    })
  },[data ,mutate, replace, toggle])
  const isDisabled = useMemo(()=>{
    if(showcaseConfig.expirationType === "flexible" && !data.expiresIn){
      return true
    }
    if(!data.email) return true;
    if(showcaseConfig.disableSelfHosting && self_email?.toLowerCase().trim() === data.email?.toLowerCase().trim()){
      return true;
    }
    if(!isValidEmail(data.email)) return true;
    return !data.name ||!data.email || !data.sub_id
  },[data.email, data.expiresIn, self_email, data.name, data.sub_id, showcaseConfig.expirationType])
  const [link, setSubId] = usePartyHostLink(data.sub_id)
  return <>
    <StyledButton className="btn btn-primary" onClick={toggle}>
      <FormattedMessage id={"New party"}/>
    </StyledButton>
    <Modal
        disabled={isDisabled}
        confirmLoading={saving}
        onSubmit={onSubmit}
        title={"New party"} okText={"Submit"} onCancel={toggle} visible={visible}>
      <div className="d-none party-title-input">
        <FormGroup label={"Party Title"} required>
          <Input type="text" name={"title"} value={data.title} onChange={setData('title')} />
        </FormGroup>
      </div>
      <FormGroup label={"Host's Name"} required>
            <Input type="text" name={"name"} value={data.name} onChange={setData('name')} />
          </FormGroup>
          <FormGroup label={"Host's Email Address"} required>
            <Input type="email" name={"email"} value={data.email} onChange={setData('email')} />
          </FormGroup>
      {/*{*/}
      {/*  Array.isArray(showcaseConfig.conditions) && showcaseConfig.conditions.some((a)=>a.condition === "referred_bookings") ?*/}
      {/*      <>*/}
      {/*        <FormGroup label={"Related event"}>*/}
      {/*          <ActiveEventsPicker onChange={setData('parent_showcase_id')} value={data.parent_showcase_id}/>*/}
      {/*        </FormGroup>*/}
      {/*      </> : null*/}
      {/*}*/}
      <div className="col-md-6 party-code-input">
        <FormGroup label={"Party code"} required>
          <Input type="text"
                 value={data.sub_id}
                 onChange={(value)=>{
                   const sub_id = value.replaceAll(/[^a-zA-Z0-9\-]/g,'')
                   setData('sub_id')(sub_id)
                   setSubId(sub_id)
                 }}

          />
        </FormGroup>
      </div>
      <FormGroup label={"Party link"}>
        <CopyButton text={link} title={link? link.replace('https://','') : link}
          className={"btn btn-link d-block text-left text-sm btn-sm px-0"}
        />
      </FormGroup>
      <div className="row">
        <div className="col-6 party_start_date_input">
          <FormGroup label={"Start date"} required>
            <Input type="date" name={"date"} min={today} value={data.starts_at}
                   onChange={setData('starts_at')} />
          </FormGroup>
        </div>
        <div className="col-6">
          {
            showcaseConfig.expirationType === "flexible" ? <>
              <FormGroup label={"End party in"} required>
                <InputGroup type={"number"} min={showcaseConfig.expireMin || 0}
                            value={data.expiresIn}
                            max={showcaseConfig.expireMax} suffix={"days"}
                            onChange={(e)=>setData('expiresIn')(e.target.value)}/>
              </FormGroup>
            </> :  <RenderEndTime starts_at={data.starts_at} expiresIn={showcaseConfig.expiresIn} />
          }
        </div>
      </div>

      {
        showcaseConfig.expirationType === "flexible" ? <>
          <RenderEndTime starts_at={data.starts_at} expiresIn={data.expiresIn} />
        </> : null
      }

      {
        error ? <p className="alert alert-danger">
          <FormattedMessage id={error.code} values={{value: error.value}} />
        </p> : null
      }
  </Modal>

    </>
}
function CopyPublicLink({ref_code, sub_id}){
  const partner_portal_subdomain = useSelector((state)=>state.settings.partner_portal_subdomain)
  const [copied, setCopied] = useState(false)
  function onCopy(e){
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1000);
  }
  return (
      <CopyToClipboard text={`https://${partner_portal_subdomain}/e/${ref_code}-${sub_id}`}
                       onCopy={onCopy}>
        <button title={"Copy public page link"} type={"button"} className={`copy-public-link word-break btn`}
                disabled={copied}>{!copied ?<FiCopy style={{width:22, height:22, strokeWidth:1}}/> :<FiCheck style={{width:22, height:22, strokeWidth:1}} />}</button>
      </CopyToClipboard>
  );
}


function ActiveEventsPicker({value, onChange}){
  const {data, isLoading} = useSwr('/showcases?status=active', get)
  const options = (data?.showcases || []).map((i)=>{
    return {
      label: `${i.hostName} (${i.hostEmail})`,
      value: i._id
    }
  })
  return <Select options={options} hasEmpty value={value} onChange={onChange}/>
}

function RenderEndTime({starts_at, expiresIn}){
  const endDate = useMemo(()=>{
    return dayjs(starts_at).add(expiresIn,'days').toDate()
  },[expiresIn, starts_at])
  if(!expiresIn){
    return null
  }
  return <div className={"text-center"}>
      <FormattedMessage id={"Party_end_time"}
                        defaultMessage={"Party will end on {endDate} ({relativeTime})"}
        values={{
          endDate: <FormattedDate value={endDate}
                                   day={"numeric"} month={"long"} year={endDate.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined} />,
          relativeTime: <FormattedRelativeTime unit={"days"} value={expiresIn} />
        }}
      />
    </div>
}

export default PartyLinksIndex;
